var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "ticket-column-card" }, [
    _c(
      "div",
      { staticClass: "column-content" },
      [
        _c(
          "div",
          {
            staticClass: "column-header",
            on: {
              mouseover: function ($event) {
                _vm.showSelectAll = true
              },
              mouseleave: function ($event) {
                _vm.showSelectAll = false
              },
            },
          },
          [
            _c("h3", [
              _vm._v(
                _vm._s(_vm.group.title) +
                  " (" +
                  _vm._s(_vm.group.tickets.length) +
                  ")"
              ),
            ]),
            _vm._v(" "),
            _vm.showSelectAll
              ? _c("div", { staticClass: "select-all-checkbox" }, [
                  _c("input", {
                    attrs: { type: "checkbox" },
                    domProps: { checked: _vm.isAllSelected },
                    on: { change: _vm.toggleSelectAll },
                  }),
                ])
              : _vm._e(),
          ]
        ),
        _vm._v(" "),
        _c(
          "draggable",
          {
            staticClass: "tickets-list",
            attrs: {
              options: _vm.ticketDragOptions,
              group: { name: "tickets", pull: true, put: true },
              disabled: _vm.isSelectionMode,
            },
            on: { add: _vm.onAdd },
            model: {
              value: _vm.group.tickets,
              callback: function ($$v) {
                _vm.$set(_vm.group, "tickets", $$v)
              },
              expression: "group.tickets",
            },
          },
          [
            _c(
              "transition-group",
              {
                staticClass: "ticket-drag",
                attrs: { tag: "div", name: "list" },
              },
              _vm._l(_vm.group.tickets, function (ticket) {
                return _c(
                  "div",
                  {
                    key: ticket._id,
                    staticClass: "ticket-item",
                    class: { "selection-mode": _vm.isSelectionMode },
                    attrs: {
                      "data-id": ticket._id,
                      "data-status": ticket.status,
                    },
                    on: {
                      click: function ($event) {
                        return _vm.handleTicketClick(ticket._id)
                      },
                    },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "ticket-select-checkbox",
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                          },
                        },
                      },
                      [
                        _c("input", {
                          attrs: { type: "checkbox" },
                          domProps: {
                            checked: _vm.isTicketSelected(ticket._id),
                          },
                          on: {
                            change: function ($event) {
                              return _vm.toggleTicketSelection(ticket._id)
                            },
                          },
                        }),
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "ticket-content" }, [
                      _c("div", { staticClass: "ticket-details" }, [
                        _c("span", { staticClass: "ticket-subject" }, [
                          _vm._v(_vm._s(ticket.subject)),
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "ticket-person" }, [
                          _c("i", { staticClass: "material-icons" }, [
                            _vm._v("person"),
                          ]),
                          _vm._v(
                            "\n                                " +
                              _vm._s(_vm.getVisitorValue(ticket, "name"))
                          ),
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "ticket-email" }, [
                          _c("i", { staticClass: "material-icons" }, [
                            _vm._v("email"),
                          ]),
                          _vm._v(
                            "\n                                " +
                              _vm._s(_vm.getVisitorValue(ticket, "email"))
                          ),
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "ticket-phone" }, [
                          _c("i", { staticClass: "material-icons" }, [
                            _vm._v("phone"),
                          ]),
                          _vm._v(
                            "\n                                " +
                              _vm._s(_vm.getVisitorValue(ticket, "phone"))
                          ),
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "ticket-type" }, [
                          _vm._v(_vm._s(ticket.type)),
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "ticket-assigned" }, [
                          _c("i", { staticClass: "material-icons" }, [
                            _vm._v("assignment_ind"),
                          ]),
                          _vm._v(
                            "\n                                " +
                              _vm._s(
                                _vm.$t("ticket.agentAssignLine", {
                                  name: ticket.assignedUser
                                    ? ticket.assignedUser.name
                                    : _vm.$t("ticket.unassigned"),
                                })
                              ) +
                              "\n                            "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "ticket-date" }, [
                          _vm._v(_vm._s(_vm.formatDate(ticket.createdDate))),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "ticket-status" }, [
                        _vm._v(_vm._s(ticket.status)),
                      ]),
                    ]),
                  ]
                )
              }),
              0
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }